module.exports = __webpack_public_path__ + "school/img/keyanxiezuo.af0afcd2.jpg";